const ComparisonChecklist = () => {
  const checklistItems = [
    {
      category: 'Credentials & Experience',
      items: [
        'Valid Texas contractor license and El Paso business permit',
        'Minimum 5+ years fence installation experience',
        'Portfolio of completed fence projects in El Paso',
        'Specialized expertise in your desired fence type'
      ]
    },
    {
      category: 'Insurance & Protection',
      items: [
        'General liability insurance coverage',
        'Workers compensation insurance for crew',
        'Property damage protection guarantee',
        'Written warranty on materials and workmanship'
      ]
    },
    {
      category: 'Project Planning',
      items: [
        'Free on-site consultation and measurements',
        'Detailed written estimate with material specifications',
        'Clear timeline with start and completion dates',
        'Handles all permit applications and approvals'
      ]
    },
    {
      category: 'Quality & Service',
      items: [
        'Uses premium-grade fencing materials',
        'Professional installation crew with proper equipment',
        'Positive customer reviews and references',
        'Post-installation cleanup and debris removal'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Fence Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare fence contractors in El Paso, ensuring you hire a qualified professional for your fencing project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-orange-50 rounded-lg p-8"
            >
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-orange-600 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-orange-600 rounded-lg p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Find Your Fence Contractor?
          </h3>
          <p className="text-lg mb-6 opacity-90">
            Connect with pre-screened, licensed fence contractors who meet these quality standards
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Quotes Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default ComparisonChecklist;
